import React from 'react'
import { Transaction } from 'services'
import { WidgetButton } from './styled'
import transactionObject from 'mocks/transaction'
import { updateTransactionToast } from 'components/notifications'
import { useStore } from 'services/store'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useWindowSize } from 'hooks'

const TransactionApprovalButton: React.FC = () => {
  const buttonState = { disabled: false, text: 'Confirm transaction' }
  const { isDarkMode } = useStore()
  const { isMobile, isTablet } = useWindowSize()
  const isSmall = isMobile || isTablet
  const { run, currentStep, setMenuOpen, setCurrentStep, startTour, stopTour } = useTourGuide()
  const handleClick = () => {
    const tx = transactionObject as unknown as Transaction

    updateTransactionToast(tx, isDarkMode)
    if (run && currentStep === 11) {
      if (isSmall) {
        setMenuOpen('OPEN')
        stopTour()
        setTimeout(() => {
          startTour()
          setCurrentStep(12)
        }, 1000)
      } else {
        setMenuOpen('OPEN')
        startTour()
        setTimeout(() => {
          setCurrentStep(12)
          startTour()
        }, 750)
      }
    }
  }

  React.useEffect(() => {
    if (!run && currentStep === 11) {
      startTour()
    }
  }, [currentStep])

  return (
    <div id="tour-confirm-transaction">
      <WidgetButton
        className="tour-confirm-transaction"
        buttonType={'primary'}
        text={buttonState.text}
        fontType={'p'}
        onClick={handleClick}
        disabled={false}
        icon={undefined}
      />
    </div>
  )
}
export default TransactionApprovalButton
